import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";
import { seoCfg, setSeoCfg, modeCanonical } from "../lib/seo";
import { CANON } from "../data/nap";

export const SeoModeGuard = () => {
  const location = useLocation();
  const [cfg, setCfg] = useState(seoCfg());

  useEffect(() => {
    api.get("/seo/config")
      .then(({ data }) => { setSeoCfg(data); setCfg(data); })
      .catch(() => { const live = { mode: "live", canonical_host: CANON }; setSeoCfg(live); setCfg(live); });
  }, []);

  useEffect(() => {
    const premig = cfg.mode === "premigration";
    let m = document.getElementById("seo-mode-robots");
    if (premig) {
      if (!m) {
        m = document.createElement("meta");
        m.id = "seo-mode-robots";
        m.name = "robots";
        document.head.appendChild(m);
      }
      m.content = "noindex,nofollow";
    } else if (m) {
      m.remove();
    }
    const href = premig || cfg.canonical_host ? modeCanonical(location.pathname) : null;
    if (href) {
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = href;
    }
  }, [cfg, location.pathname]);

  return null;
};
